import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from './../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';
import SeccionPageHeader from './../../Utils/SeccionPageHeader';
import CargandoSpinner from './../../Utils/CargandoSpinner';

export default function DiagSeguridadAlimentaria(){
    const {token} = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [datosSeguridadAlimentaria, setDatosSeguridadAlimentaria] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatoseguridadalimentaria?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosSeguridadAlimentaria(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionPersona (row){
                return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.per_idpersona} row={row} />
            }
    const columns = [
            {
                name: 'Acciones',
                cell: row => verAtencionPersona(row),
                ignoreRowClick: true,
                width: '3%'
            },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width: '100px' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '200px' },
        { name: 'Tipo de espacio', selector: row => row.seg_tipo_espacio, sortable: true, width: '200px' },
        { name: 'Área del espacio (m²)', selector: row => row.seg_areaespacio, sortable: true, width: '200px' },
        { name: 'Escombros presentes?', selector: row => row.seg_escombros, sortable: true, width: '150px' },
        { name: 'Plantas/cultivos establecidos?', selector: row => row.seg_plantascultivos, sortable: true, width: '200px' },
        { name: 'Observaciones del lote', selector: row => row.seg_observaciones, sortable: true, width: '250px' },
        { name: 'Materia orgánica presente?', selector: row => row.seg_materiaorganica, sortable: true, width: '200px' },
        { name: 'Disponibilidad de agua?', selector: row => row.seg_disponibilidadagua, sortable: true, width: '200px' },
        { name: 'Prácticas de conservación?', selector: row => row.seg_practicasconservacion, sortable: true, width: '200px' },
        { name: 'Nombre de la práctica de conservación', selector: row => row.seg_nombrepractica, sortable: true, width: '250px' },
        { name: 'Observaciones sobre recursos naturales', selector: row => row.seg_observacionesestarecursos, sortable: true, width: '250px' },
        { name: 'Experiencia en sistemas agroecológicos?', selector: row => row.seg_tieneexperiencia, sortable: true, width: '250px' },
        { name: 'Tiempo de experiencia (meses)', selector: row => row.seg_tiempoexperiencia, sortable: true, width: '200px' },
        { name: 'Observaciones sobre experiencia agroecológica', selector: row => row.seg_observacionesagroecologicos, sortable: true, width: '250px' }
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoseguridadalimentaria?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_seguridad_alimentaria.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Diagnostico seguridad alimentaria"
                idCabezaFamilia="1"
                url="/consultas/verdiagnosticos"
                nombreurl="Diagnosticos"
                nombreform="Seguridad alimentaria"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos/>
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosSeguridadAlimentaria} titulo="Seguridad Alimentaria" exportarCSV={exportarCSV}/>
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Seguridad alimentaria"
                                    columns={columns}
                                    data={datosSeguridadAlimentaria}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}